<template>
  <v-container class="pa-0">
    <v-row>
      <v-col :cols="12" :md="6">
        <subscription-item-details
          :index="index"
          :subscriptionGroup="subscriptionGroup"
          :isCurrentlyCancellable="subscriptionGroup.subscriptions[0].currently_cancellable"
          :showChangeCreditCardDialog="showChangeCreditCardDialog"
          :showChangeSubscriptionDialog="showChangeSubscriptionDialog"
          :showAddCouponDialog="showAddCouponDialog"
          :showCancelSubscriptionDialog="showCancelSubscriptionDialog"
        />
      </v-col>
      <v-col :cols="12" :md="6">
        <subscription-item-products
          :subscriptionGroup="subscriptionGroup"
          :language="language"
          :isCurrentlyCancellable="subscriptionGroup.subscriptions[0].currently_cancellable"
          :showAddAdditionalCompanyDialog="showAddAdditionalCompanyDialog"
          :showCancelSubscriptionDialog="showCancelSubscriptionDialog"
        />
      </v-col>
    </v-row>
    <v-divider class="my-3"/>
  </v-container>
</template>

<script>
import moment from 'moment';
import SubscriptionItemDetails from './SubscriptionItemDetails.vue';
import SubscriptionItemProducts from './SubscriptionItemProducts.vue';

export default {
  name: 'SubscriptionItem',
  components: {
    SubscriptionItemProducts,
    SubscriptionItemDetails,
  },
  props: {
    subscriptionGroup: {
      type: Object,
    },
    index: {
      type: Number,
    },
    language: {
      type: String,
    },
    showAddAdditionalCompanyDialog: {
      type: Function,
      default: () => {},
    },
    showChangeCreditCardDialog: {
      type: Function,
      default: () => {},
    },
    showChangeSubscriptionDialog: {
      type: Function,
      default: () => {},
    },
    showAddCouponDialog: {
      type: Function,
      default: () => {},
    },
    showCancelSubscriptionDialog: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
